module.exports = __webpack_public_path__ + "static/media/folder-icon2.7ee9f2d6.svg";